import { Button, Content, ExpandableSection } from "@patternfly/react-core";
import type { FC, ReactElement } from "react";
import { Link } from "react-router-dom";
import { useProductMetadata } from "../../../../hooks/useProductMetadata";
import Env from "../../../../utils/env";

interface ProductScoreActionItemProps {
	title: string;
	description?: string | undefined;
	htmlDescription?: string | undefined;
	subItem?: string | ReactElement | undefined;
	buttonText?: string | undefined;
	buttonType?: "link" | "external" | undefined;
	buttonPath?: string | undefined;
	expandedId?: string | undefined;
	setExpandedId?: ((id: string | null) => void) | undefined;
	itemId?: string | undefined;
}

export const ProductScoreActionItem: FC<ProductScoreActionItemProps> = ({
	title,
	description,
	buttonText,
	buttonPath,
	buttonType,
	subItem,
	htmlDescription,
}) => {
	const { productDetail } = useProductMetadata();
	return (
		<ExpandableSection className="product-score-action-item" isIndented toggleText={title}>
			{description && (
				<Content>
					<Content component="p" className="small-text">
						{description}
					</Content>
				</Content>
			)}
			{htmlDescription && (
				<Content className="small-text">
					<pfe-markdown>
						<div pfe-markdown-container="" className="small-text">
							{htmlDescription}
						</div>
					</pfe-markdown>
				</Content>
			)}
			{subItem && subItem}
			{buttonType === "external" && (
				<Button className={"action-button"} variant="secondary" component={"a"} href={buttonPath}>
					{buttonText}
				</Button>
			)}
			{buttonType === "link" && (
				<Button
					className={"action-button"}
					variant="secondary"
					component={(props) => (
						<Link to={`${Env.routePrefix}/products/${productDetail?._id}/${buttonPath}`} {...props} />
					)}
				>
					{buttonText}
				</Button>
			)}
		</ExpandableSection>
	);
};
